var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "requisitions-applicants grid-x grid-padding-x grid-padding-y top-margin bg-white border mt-3 applicant-container"
    },
    [
      _c("div", { staticClass: "cell medium-12" }, [
        _c("div", [
          _c("label", { staticClass: "filter-label p-2" }, [
            _vm._v("Applicants")
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedPhase,
                  expression: "selectedPhase"
                }
              ],
              staticClass: "mt-3",
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.selectedPhase = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  function($event) {
                    return _vm.loadPosts(true)
                  }
                ]
              }
            },
            _vm._l(_vm.allPhases, function(phase) {
              return _c("option", { key: phase, domProps: { value: phase } }, [
                _vm._v(
                  _vm._s(
                    phase == "loading_cv"
                      ? "Loading CV"
                      : _vm.toTitleCase(phase)
                  )
                )
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "search-box mt-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchTerm,
                  expression: "searchTerm"
                }
              ],
              staticClass: "long-placeholder",
              attrs: {
                type: "text",
                placeholder: "Search candidate (name, surname, ID, etc.)"
              },
              domProps: { value: _vm.searchTerm },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchTerm = $event.target.value
                  },
                  _vm.handleInput
                ]
              }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchTerm,
                  expression: "searchTerm"
                }
              ],
              staticClass: "short-placeholder",
              attrs: { type: "text", placeholder: "Search candidate" },
              domProps: { value: _vm.searchTerm },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchTerm = $event.target.value
                  },
                  _vm.handleInput
                ]
              }
            }),
            _vm._v(" "),
            _c("i", { staticClass: "fa fa-solid fa-search icon" })
          ]),
          _vm._v(" "),
          _c("div", [
            _c("small", [
              _vm._v("Total Applicants: " + _vm._s(_vm.totalApplicant))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "small-12" }, [
        _c("div", { staticClass: "p-2" }, [
          _vm.hasMore
            ? _c(
                "button",
                {
                  staticClass: "btn btn-success mycalling-green",
                  attrs: { disabled: _vm.showSpinner },
                  on: { click: _vm.loadMore }
                },
                [_vm._v("\n                Load More\n            ")]
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "applicantsList" },
          [
            _vm.showSpinner
              ? _c("div", { staticClass: "spinner" }, [
                  _c("i", { staticClass: "fa fa-solid fa-spinner fa-spin" }),
                  _vm._v(" Loading....\n            ")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.applicants, function(applicant) {
              return _c(
                "div",
                {
                  key: "APPLICANT" + applicant.id,
                  staticClass: "applicant-card",
                  class: {
                    active: applicant.id === _vm.selectedApplicantId,
                    clicked: _vm.hasClicked.includes(applicant.id)
                  },
                  on: {
                    click: function($event) {
                      return _vm.loadDetail(applicant.id)
                    }
                  }
                },
                [
                  _c("h6", [_vm._v(_vm._s(applicant.user.full_name))]),
                  _vm._v(" "),
                  applicant.user.user_detail !== null &&
                  applicant.user.user_detail.user_detail_jobs[0] !== undefined
                    ? _c("div", [
                        applicant.user.user_detail.user_detail_jobs[0] &&
                        applicant.user.user_detail.user_detail_jobs[0].role
                          ? _c("div", { staticClass: "date" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    applicant.user.user_detail
                                      .user_detail_jobs[0].role.title
                                  ) +
                                  "\n                    "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  applicant.user.baseline_score
                    ? _c("div", [
                        _vm._v(
                          "\n                    Baseline Score: " +
                            _vm._s(applicant.user.baseline_score) +
                            "\n                "
                        )
                      ])
                    : _vm._e()
                ]
              )
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "p-2" }, [
          _vm.hasMore
            ? _c(
                "button",
                {
                  staticClass: "btn btn-success mycalling-green",
                  attrs: { disabled: _vm.showSpinner },
                  on: { click: _vm.loadMore }
                },
                [_vm._v("\n                Load More\n            ")]
              )
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-071a47ab", { render: render, staticRenderFns: staticRenderFns })
  }
}